import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { CommonAxiosError } from '@telialt/models/src/ErrorModelMS';
import { useSegment } from '@telialt/utils/src/segment';

import { postMarketingConsent } from '../api';
import { MUTATION_KEYS, QUERY_KEYS } from '../constants';
import { AcceptMarketingConsent } from '../model';

export const useAcceptMarketingConsentMutation = () => {
    const segment = useSegment();
    const queryClient = useQueryClient();

    return useMutation<AxiosResponse, CommonAxiosError, AcceptMarketingConsent>({
        mutationKey: [MUTATION_KEYS.ACCEPT_MARKETING_CONSENT, segment],
        mutationFn: (requestData) => postMarketingConsent(segment, requestData),
        onSuccess: async () => {
            await Promise.all([
                queryClient.resetQueries({ queryKey: [QUERY_KEYS.MARKETING_CONSENT, segment] }),
                queryClient.resetQueries({ queryKey: [QUERY_KEYS.SELF_SERVICE_SERVICE_OFFERS, segment], exact: false }),
            ]);
        },
    });
};
